<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Tabs/other'
 * Name: Tooltip
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=11884-93270&t=ldymHtYK0zJDKBqF-4
 */
import type { TooltipPrimaryProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TooltipPrimary',
})

withDefaults(defineProps<TooltipPrimaryProps>(), {
  is: 'span',
})
</script>

<template>
  <component
    :is="is"
    class="ui-tooltip-primary"
  >
    <AppText
      name="body2"
      tag="div"
      color="white"
    >
      <span v-html="text" />
    </AppText>
  </component>
</template>

<style lang="scss" scoped src="../styles/_tooltip-primary.scss" />
